import routes from "src/routes";
import ray from "src/config/ray";

const routesList = routes.find((page) => page.children).children;
const dashboardTabs = routesList.map((u) =>
  Object.assign({}, u, { approved: true })
);

dashboardTabs.map((key) => {
  let config = { slug: key };
  switch (key) {
    case "ahkam":
      config.title = "کاربران";
      config.icon = "user1";
      break;
    default:
      break;
  }
});

const config = {
  axiosBaseUrl: process.env.REACT_APP_URL,
  sitekey: process.env.REACT_APP_SITEKEY,
  dashboardTabs,
  ray,
  version: "2.0.1",
};

export default config;
